import enumsJson from '../../demo/fixtures/enums.json'
import copyW4Json from '../../demo/fixtures/w4/copy.json'
import { marketLabel } from '../../demo/store'
import type { Campaign, Product } from '../../demo/types'
import { AutopilotBadge, Badge, Button, Spinner } from '../../ui'
import styles from './TaskDetailPage.module.css'

interface DetailHeaderProps {
  campaign: Campaign
  product: Product
  busy: boolean
  autopilotOn: boolean
  onEdit: () => void
  onPrimary: () => void
}

const statusTone = enumsJson.statusTone as Record<Campaign['status'], 'green' | 'red' | 'orange' | 'gray'>
const copyW4 = copyW4Json as { badgeOn: string }

function primary(campaign: Campaign): { label: string; variant: 'primary' | 'secondary'; disabled: boolean } {
  if (campaign.status === 'pending') return { label: '确认投放', variant: 'primary', disabled: false }
  if (campaign.status === 'running') return { label: '暂停投放', variant: 'secondary', disabled: false }
  if (campaign.status === 'paused') return { label: '恢复投放', variant: 'primary', disabled: false }
  if (campaign.status === 'attention') return { label: '确认投放', variant: 'primary', disabled: true }
  return { label: '已完成', variant: 'primary', disabled: true }
}

export function DetailHeader({ campaign, product, busy, autopilotOn, onEdit, onPrimary }: DetailHeaderProps) {
  const action = primary(campaign)
  const audience = campaign.audience.type === 'smart' ? '智能推荐' : `自定义 · ${campaign.audience.ageBands.length}\u00A0个年龄段`
  const attributes = [
    ['目标', enumsJson.objective[campaign.objective]],
    ['投放地区', campaign.markets.map(marketLabel).join('、')],
    ['每日预算', `$${campaign.budget.dailyMin}–$${campaign.budget.dailyMax}`],
    ['受众', audience],
  ]
  return (
    <header className={styles.detailHeader} data-scope="detail-header">
      <img className={styles.headerImage} src={`/${product.image}`} alt={product.name} />
      <div className={styles.headerIdentity}>
        <h1>{campaign.adName}</h1>
        <p>{product.name} · {product.spec}</p>
        <div className={styles.statusLine}><Badge tone={statusTone[campaign.status]} pill>{enumsJson.status[campaign.status]}</Badge>{autopilotOn ? <span className={styles.autopilotBadgeScope} data-scope="ap-badge"><AutopilotBadge size="md" label={copyW4.badgeOn} /></span> : null}</div>
      </div>
      <div className={styles.attributes}>{attributes.map(([label, value]) => <div className={styles.attribute} key={label}><p>{label}</p><b>{value}</b></div>)}</div>
      <div className={styles.headerActions}>
        <Button variant="secondary" size="pill-sm" onClick={onEdit}>编辑设置</Button>
        <Button variant={action.variant} size="pill-sm" disabled={action.disabled || busy} onClick={onPrimary}>{busy ? <><Spinner />处理中…</> : action.label}</Button>
      </div>
    </header>
  )
}
